import { Button as MantineButton, ButtonProps as MantineButtonProps } from "@mantine/core";
import { useAtomValue } from "jotai";

import { themeConfigAtom } from "atoms/clientConfig";

import { SizeVariant } from "./sizeVariants";
import { ButtonType, mantineVariantsMap } from "./typeVariants";
import { useButtonStyles } from "./useButtonStyles";

export type ButtonProps = MantineButtonProps<any> & {
  sizeVariant?: SizeVariant;
  typeVariant?: ButtonType;
  dataTestId?: string;
};

export const Button = ({
  children,
  sizeVariant = "large",
  typeVariant = "primary",
  dataTestId = "",
  disabled,
  ...mantineButtonsProps
}: ButtonProps) => {
  const themeConfig = useAtomValue(themeConfigAtom);
  const { classes } = useButtonStyles({ sizeVariant, typeVariant });
  // Checks to apply correctly the gradient background
  const hasGradientBg = themeConfig.buttons.gradient! && !disabled;
  const buttonType = typeVariant === "primary" && hasGradientBg ? "gradient" : mantineVariantsMap[typeVariant];

  return (
    <MantineButton
      radius={themeConfig.buttons.borderRadius}
      variant={buttonType}
      classNames={{ root: classes.button, leftIcon: classes.leftIcon }}
      data-testid={dataTestId}
      disabled={disabled}
      {...mantineButtonsProps}
    >
      {children}
    </MantineButton>
  );
};
